import type { CSSProperties } from 'react'
import styles from './nodeDetail.module.css'

interface ActionBtnProps {
  label: string
  disabled: boolean
  onClick: () => void
  color: string
}

export function ActionBtn({ label, disabled, onClick, color }: ActionBtnProps) {
  const cssVars = { '--action-color': color } as CSSProperties

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={styles.actionButton}
      style={cssVars}
    >
      {label}
    </button>
  )
}
